<template>
  <div class="Management">
    <div v-if="!addShow">
      <div class="top">
        <div class="tabList">
          <div
            class="item"
            @click="onTab(v, i)"
            :class="{ active: i == tabI }"
            v-for="(v, i) in seniorityList"
            :key="v.typeName"
          >
            {{ v.typeName }}
          </div>
        </div>

        <div class="title">
          <el-button type="primary" size="small" @click="add"
            >新增专业服务</el-button
          >
        </div>
        <!-- <div class="title">专业服务列表</div> -->
      </div>

      <div
        class="content_list list"
        v-show="dataList.length != 0"
        @scroll="scrollTask"
      >
        <div class="content_box" style="margin-top: 10px">
          <el-alert
            :closable="false"
            title="一个完整的专业服务包括3部分：专业服务基本信息、服务项目、流程节点，添加专业服务时请确保这三部分都已填写完整。"
            type="warning"
          ></el-alert>

          <div
            class=""
            style="border-bottom: 1px #ededed solid"
            v-for="(el, i) in dataList"
            :key="i"
            @click="goDetails(el)"
          >
            <div class="item_apply_box1">
              <div class="num_label">
                <div class="box">{{ i + 1 }}</div>
              </div>
              <div class="practice_name" style="flex: 1">
                <div class="time_box practic">
                  {{ el.name || '未填写完成' }}
                  <div
                    class=""
                    style="
                      display: flex;
                      color: #326afb;
                      font-weight: 600;
                      cursor: pointer;
                      font-size: 15px;
                      box-sizing: border-box;
                    "
                  >
                    <div
                      style="
                        color: #333;
                        font-weight: 600;
                        cursor: pointer;
                        font-size: 15px;
                        margin-right: 20px;
                        box-sizing: border-box;
                      "
                    >
                      编辑
                    </div>
                    <div @click.stop="goServiceItemsPage(el)">服务项目配置</div>
                  </div>
                </div>
                <div class="time_box" style="margin: 10px 0">
                  {{ el.brief || '暂无简介' }}
                </div>
              </div>
            </div>
            <div class="bot_box_big">
              <div class="time_box">{{ el.createTime }}</div>
              <div class="">
                <div
                  class="fun"
                  v-if="el.status == 0"
                  @click.stop="changeStatus(el, 0)"
                >
                  <img :src="imgUrl + 'suspend_service.png'" mode="" />
                  暂停
                </div>
                <div class="fun" v-else @click.stop="changeStatus(el, 1)">
                  <img :src="imgUrl + 'firing_img.png'" mode="" />
                  启动
                </div>
                <div class="fun" @click.stop="deleteData(el)">
                  <img :src="imgUrl + 'editedBooks_del.png'" mode="" />
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-show="dataList.length == 0">
        <img :src="require('assets/images/kong.png')" alt="" />
        <div>暂无专业服务</div>
      </div>
    </div>
    <div v-if="addShow">
      <addPage
        :formLabelAlign="formLabelAlign"
        :fileList="fileList"
        :active="active"
        ref="addpage"
        :ser_list="ser_list"
        @delServices="delServices"
        @uploads="$refs.files.click()"
        @onSubmit="onSubmit"
      />
    </div>
    <!-- 新增服务项目 -->
    <el-dialog
      title="添加服务项目名称"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="textarea"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false
            textarea = ''
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="confime">确 定</el-button>
      </span>
    </el-dialog>
    <input
      type="file"
      style="display: none"
      @change="doRealUpload"
      ref="files"
    />
  </div>
</template>

<script>
import addPage from './addPage'
import qs from 'qs'
import {
  servicesProductList,
  userPracticingQualification,
  listOfServiceItems,
  addServicesProduct,
  addListOfServiceItems,
  deleteServicesProducts,
  modifyServices,
  deleteServices,
  ossUpload,
} from 'api/professionServer'
export default {
  components: {
    addPage,
  },
  // props: ['dataList'],
  data() {
    return {
      dialogVisible: false,
      addShow: false,
      active: 1,
      tabI: 0,
      textarea: '',
      dataList: [],
      seniorityList: [], // 执业资格列表
      tarid: '',
      ser_list: [],
      imgList: [],
      fileList: [], //上传数组
      tarids: '',
      formLabelAlign: {
        requirements: '', //相关要求
        name: '', //服务名称
        contact: '', //联系方式

        brief: '', //介绍
      },
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
    }
  },
  created() {
    this.userPracticing()
  },
  methods: {
    // 提交
    async onSubmit() {
      if (!this.formLabelAlign.contact)
        return this.$message.error('请输入联系方式')
      let opt = {
        ...this.formLabelAlign,
        fileJson: JSON.stringify(this.imgList),
      }
      let res = await addServicesProduct(opt)
      if (res.code !== 200) return this.$message.error(res.data)
      this.$confirm(
        '专业服务基本信息添加成功，是否现在为其配置具体服务项目?您也可以稍后在专业服务的“服务项目管理”中去添加。',
        '提示',
        {
          confirmButtonText: '现在配置',
          cancelButtonText: '稍后配置',
        }
      )
        .then(() => {
          this.active = 2
          this.listOfServiceItems(this.formLabelAlign.id)
        })
        .catch(() => {
          this.serviceType = 2
        })
    },
    // 上传图片
    async doRealUpload(e) {
      let file = e.target.files[0]
      this.fileList.push(file.name)
      let form = new FormData()
      form.append('file', file)
      const res = await ossUpload(form)
      if (res.code === 200) {
        this.imgList.push({
          path: res.data,
          name: file.name,
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }

      // console.log(res);
    },
    delServices(item) {
      this.$confirm('是否删除该服务项', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteServicesProducts(
            qs.stringify({
              id: item.id,
            })
          )
          if (res.code !== 200) return
          this.listOfServiceItems(this.formLabelAlign.id)
        })
        .catch(() => {})
    },
    // 新增服务项目
    async confime() {
      if (!this.textarea) {
        this.$message.error('请输入服务名称')
        return
      }
      let opt = {
        projectName: this.textarea,
        servicesId: this.formLabelAlign.id,
      }
      let res = undefined
      // if (this.type === 1) {
      res = await addListOfServiceItems(opt)
      // } else if (this.type === 2) {
      // 	opt.id = this.xzItem.id;
      // 	res = await addListOfServiceItems(JSON.stringify(opt));
      // }
      if (res.code !== 200) return this.$message.error(res.data)
      this.dialogVisible = false
      this.textarea = ''
      this.listOfServiceItems(this.tarids)
      // if (this.type === 1) {
      this.$confirm(
        '服务信息添加成功，是否现在为其配置具体流程节点? 您也可以稍后在服务项目的“流程节点配置”中去添加。',
        '提示',
        {
          confirmButtonText: '现在配置',
          cancelButtonText: '稍后配置',
        }
      )
        .then(() => {
          this.active = 3
          this.$refs.addpage.getProjectProcess()
        })
        .catch(() => {})
      // }
    },
    // 服务项目列表
    async listOfServiceItems(id) {
      let res = await listOfServiceItems({
        servicesId: id,
      })
      if (res.code !== 200) return
      this.ser_list = res.data
    },
    add() {
      this.active = 1
      this.addShow = true
      this.submitData()
    },
    async submitData() {
      let res = await addServicesProduct({ practiceTypeId: this.tarid })
      if (res.code !== 200) return
      this.formLabelAlign.id = res.data
    },
    onTab(value, index) {
      this.tarid = value.typeId
      this.tabI = index
      this.servicesProductList(value.typeId)
    },
    async servicesProductList(id) {
      let res = await servicesProductList(id)
      if (res.code !== 200) return
      this.dataList = res.data
    },
    // 获取执业资格
    async userPracticing() {
      let res = await userPracticingQualification()
      if (res.code !== 200) return
      this.seniorityList = res.data
      this.tarid = res.data[0].typeId
      this.servicesProductList(res.data[0].typeId)
    },
    scrollTask(e) {
      this.$emit('scrollTask', e)
    },
    deleteData(item) {
      this.$confirm('是否删除该服务', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          let res = await deleteServices(
            qs.stringify({
              id: item.id,
            })
          )
          if (res.code !== 200) return
          this.servicesProductList(this.tarid)
        })
        .catch(() => {})
    },

    async changeStatus(item, status) {
      let res = await modifyServices({
        id: item.id,
        status,
      })
      if (res.code !== 200) return
      this.servicesProductList(this.tarid)
    },
    goDetails(v) {
      this.active = 1
      this.tarids = v.id
      this.addShow = true
      this.formLabelAlign = {
        requirements: v.requirements, //相关要求
        name: v.name, //服务名称
        contact: v.contact, //联系方式
        id: v.id,
        brief: v.brief, //介绍
      }
    },
    goServiceItemsPage(v) {
      this.active = 2
      this.tarids = v.id
      this.addShow = true
      this.formLabelAlign.id = v.id
      this.listOfServiceItems(v.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.Management {
  height: 640px;

  border-radius: 10px;
  .top {
    display: flex;
    align-items: center;
    padding: 15px;
    min-height: 60px;
    max-height: 120px;
    overflow-y: auto;
    box-sizing: border-box;
    border-bottom: 1px solid #eaeaea;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 16px;
    }
    .tabList {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 15px;
      gap: 20px;
      .item {
        cursor: pointer;
        padding: 10px;
        border-radius: 5px;

        &:hover {
          background: #edf2ff;
          color: #326afb;
        }
      }

      .active {
        background: #edf2ff;
        color: #326afb;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    .tit_box {
      font-size: 16px;
      font-weight: bold;
      color: #000000;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .tip {
        font-size: 12px;
        font-weight: normal;
        color: #333;
        > text {
          color: #326afb;
        }
      }
    }
    .title {
      position: relative;
      font-size: 16px;
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
      .el-button {
        position: absolute;
        top: -10px;
        right: 0;
      }
    }
    .more {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
    }
  }
  .content_list {
    height: calc(100% - 30px) !important;
  }
  .list {
    height: calc(100% - 140px);
    overflow: auto;
    .content_box {
      width: 100%;
      min-height: 150px;
      border-radius: 10px 10px 0 0;
      background-color: #fff;
      padding: 10px 23px calc(env(safe-area-inset-bottom) + 110px);
      box-sizing: border-box;
      .bot_box_big {
        width: 100%;
        min-height: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 10px;
        color: #333;
        padding-left: 38px;
        box-sizing: border-box;

        > div {
          display: flex;
          align-items: center;
        }

        .fun {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
        }

        .time_box {
          font-size: 13px;
          color: #999999;
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .practic {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .item_apply_box1 {
        width: 100%;
        padding: 5px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .practice_name {
          > div:first-child {
            font-weight: 600;
            font-size: 15px;
            color: #222222;
          }

          .time_box {
            font-size: 13px;
            color: #999999;
            margin-top: 10px;
          }
        }
        .num_label {
          display: flex;
          align-items: center;
          margin-right: 18px;

          .box {
            font-size: 15px;
            font-weight: bold;
            color: #326afb;
            width: 21px;
            height: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f2f6ff;
            border-radius: 50%;
          }
        }
      }
    }
    .list-item {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #f7f7f7;
      padding: 10px 0;
      .top {
        display: flex;
        align-items: center;
        .index {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          background: #f2f6ff;
          border-radius: 50%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #326afb;
          // line-height: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #222222;
          flex: 1;
        }
        .accept {
          width: 79px;
          height: 28px;
          background: #f4f7ff;
          border-radius: 5px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #326afb;
          line-height: 28px;
          padding-left: 20px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #326afb;
            top: 50%;
            transform: translateY(-50%);
            left: 8px;
          }
        }
      }
      .center {
        display: flex;
        align-items: center;
        .type,
        .region {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
        .region {
          margin-left: 10px;
        }
        .demand {
          margin-left: 20px;
          flex: 1;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 15px;
          // text-align: center;
        }
        .price {
          .unit {
            font-size: 12px;
          }
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ff5346;
          line-height: 15px;
        }
      }
      .bottom {
        .createTime {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .empty {
    text-align: center;
    margin: 25% 0;
    img {
      width: 150px;
      height: 150px;
    }
    font-size: 14px;
    color: #999;
    text-align: center;
  }
}
</style>
